import type { ICreateReportCategoryCmd } from "@/data/commands/catalog/CreateReportCategoryCmd";
import { Factory } from "@/data/dao/Factory";
import { CatalogDao } from "@/data/dao/service/CatalogDao";
import type { IReportCategory } from "@/data/model/ReportCategory";

import { BaseEntityForm } from "@/portal/forms/BaseEntityForm";

export class ReportCategoryForm extends BaseEntityForm<IReportCategory, ICreateReportCategoryCmd> {
    private $nameField: JQuery;
    private $internalNoteField: JQuery;
    private $orderField: JQuery;

    constructor(element: JQuery) {
        super(element, Factory.getInstance<CatalogDao>(CatalogDao).reportCategoryDataSource);

        this.$nameField = this.$form
            .find('.form-control[name="name"]')
            .change(() => this.updateName(this.$nameField.val()));
        this.$internalNoteField = this.$form.find('.form-control[name="internalnote"]');
        this.$orderField = this.$form.find('.form-control[name="order"]')["TouchSpin"]({
            min: 1,
            max: 10000,
            step: 1,
            buttondown_class: "btn btn-secondary",
            buttonup_class: "btn btn-secondary",
            verticalbuttons: true,
            verticalup: '<i class="la la-plus"></i>',
            verticaldown: '<i class="la la-minus"></i>',
        });
    }

    public setFormData(model?: IReportCategory) {
        this.updateName(model === undefined ? "" : model.name);
        this.$nameField.val(model === undefined ? "" : model.name);
        this.$internalNoteField.val(model === undefined || model.internalNote === undefined ? "" : model.internalNote);
        this.$orderField.val(model === undefined ? undefined : (model.order as any));
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public getFormData($form: JQuery): ICreateReportCategoryCmd {
        const data: ICreateReportCategoryCmd = {
            name: this.$nameField.val().length > 0 ? this.$nameField.val() : undefined,
            internalNote: this.$internalNoteField.val().length === 0 ? undefined : this.$internalNoteField.val(),
            order: this.$orderField.val().length !== 0 ? parseInt(this.$orderField.val()) : undefined,
        };

        let hasError = false;
        if (data.name === undefined) {
            hasError = true;
            this.$nameField.addClass("is-invalid");
        }

        if (data.order !== undefined && isNaN(data.order)) {
            hasError = true;
            this.$orderField.addClass("is-invalid");
        }

        return (hasError ? undefined : data) as any;
    }
}
